import { Box } from "@mui/material";
import { useStyles } from "./style";

export const SectionDivider = ({ label }: { label: string }) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Box className={classes.label}>{label}</Box>
      <Box className={classes.line} />
    </Box>
  );
};
